import { theme } from '@frontend/theme';
import { SearchField, useFormField } from '@frontend/design-system';
import { RecipientTally } from '../recipient-tally';

type Props = {
  showTally?: boolean;
  showSearch?: boolean;
  filteredCount: number;
  totalCount: number;
  searchFieldProps: ReturnType<typeof useFormField<'text'>>;
};

export const SearchBar = ({
  showTally = true,
  showSearch = true,
  filteredCount,
  totalCount,
  searchFieldProps,
}: Props) => {
  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(1), flex: 1 }}>
      {showTally && <RecipientTally filteredCount={filteredCount} totalCount={totalCount} />}
      {showSearch && (
        <SearchField name='recipient-search' placeholder={'Search'} clearable={false} {...searchFieldProps} />
      )}
    </div>
  );
};
